(function() {
    'use strict';
    angular
        .module('liverunApp')
        .factory('PromoCodeTag', PromoCodeTag);

    PromoCodeTag.$inject = ['$resource'];

    function PromoCodeTag ($resource) {
        var resourceUrl =  'api/tags/:action/:promoCodeId/:tagId';

        /**
         * POST - /api/tags/add-medal-tag/:medalId/:tagId
         DEL - /api/tags/remove-medal-tag/:medalId/:tagId
         GET - /api/tags/medal-tags/:medalId
         */
        return $resource(resourceUrl, {}, {
            tagsAvailable : { params:{action:'all-tags'},method : 'GET', isArray: true },
            allPromoCodeTags : { params:{action:'promo-code-tags'},method : 'GET', isArray: true },
            addTag : { params:{action:'add-promocode-tag'},method : 'POST' },
            removeTag : { params:{action:'remove-promocode-tag'},method : 'DELETE' },


/*
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }*/
        });
    }
})();
